import { render, staticRenderFns } from "./AutoReplyReviewItem.vue?vue&type=template&id=73d8210e&scoped=true&"
import script from "./AutoReplyReviewItem.vue?vue&type=script&lang=js&"
export * from "./AutoReplyReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./AutoReplyReviewItem.vue?vue&type=style&index=0&id=73d8210e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d8210e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
